import axios from "axios";
import qs from "qs";

const { REACT_APP_MY_ENV } = process.env;

const axiosInstance = axios.create({
  baseURL: REACT_APP_MY_ENV,
});

export function savePhotoCampaign(values) {
  console.log("LOS DATOS");
  console.log(values);
  return new Promise((resolve, reject) => {
    axiosInstance({
      method: "post",
      url: "/mediaAd/photo",
      headers: {
        post: {
          Authorization:
            "Bearer " +
            JSON.parse(
              sessionStorage.hasOwnProperty("token_store")
                ? sessionStorage.getItem("token_store")
                : JSON.stringify({ token: "empty" })
            ).token,
          "Content-Type": "multipart/form-data",
        },
      },
      data: values,
    })
      .then((response) => {
        console.log(response.status);
        if (response.status === 200 || response.status === 201) {
          //  window.location.href = "http://localhost:3000/campaigns";

          resolve(response);
        }
        reject(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function editAdCampaign(values, id) {
  console.log("LOS DATOS");
  console.log(values);
  return new Promise((resolve, reject) => {
    axiosInstance({
      method: "put",
      url: "/mediaAd/" + id,
      headers: {
        put: {
          Authorization:
            "Bearer " +
            JSON.parse(
              sessionStorage.hasOwnProperty("token_store")
                ? sessionStorage.getItem("token_store")
                : JSON.stringify({ token: "empty" })
            ).token,
          "Content-Type": "multipart/form-data",
        },
      },
      data: values,
    })
      .then((response) => {
        if (response.status === 200 || response.status === 201) {
          // window.location.href = "http://localhost:3000/campaigns";
          resolve(response);
        }
        reject(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function saveVideoCampaign(values) {
  return new Promise((resolve, reject) => {
    axiosInstance({
      method: "post",
      url: "/mediaAd/video",
      headers: {
        post: {
          Authorization:
            "Bearer " +
            JSON.parse(
              sessionStorage.hasOwnProperty("token_store")
                ? sessionStorage.getItem("token_store")
                : JSON.stringify({ token: "empty" })
            ).token,
          "Content-Type": "multipart/form-data",
        },
      },
      data: values,
    })
      .then((response) => {
        if (response.status === 200 || response.status === 201) {
          // window.location.href = "http://localhost:3000/campaigns";

          resolve(response.data);
        }
        reject(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function saveGifCampaign(values) {
  return new Promise((resolve, reject) => {
    axiosInstance({
      method: "post",
      url: "/mediaAd/gif",
      headers: {
        post: {
          Authorization:
            "Bearer " +
            JSON.parse(
              sessionStorage.hasOwnProperty("token_store")
                ? sessionStorage.getItem("token_store")
                : JSON.stringify({ token: "empty" })
            ).token,
          "Content-Type": "multipart/form-data",
        },
      },
      data: values,
    })
      .then((response) => {
        if (response.status === 200 || response.status === 201) {
          // window.location.href = "http://localhost:3000/campaigns";
          resolve(response.data);
        }
        reject(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function loadDashboardAdsData_DataUsage(id, endDate, startDate) {
  return new Promise((resolve, reject) => {
    axiosInstance({
      method: "get",
      url: "/mediaAd/" + id + "/dataUsage",
      params: {
        startingDate: startDate,
        endingDate: endDate,
      },
      headers: {
        get: {
          Authorization:
            "Bearer " +
            JSON.parse(
              sessionStorage.hasOwnProperty("token_store")
                ? sessionStorage.getItem("token_store")
                : JSON.stringify({ token: "empty" })
            ).token,
          "Content-Type": "multipart/form-data",
        },
      },
    })
      .then((response) => {
        if (response.status === 200) {
          resolve(response);
        }
        reject(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function loadDashboardAdsData_UserUnique(id, endDate, startDate) {
  return new Promise((resolve, reject) => {
    axiosInstance({
      method: "get",
      url: "/mediaAd/" + id + "/newUsers",
      params: {
        startingDate: startDate,
        endingDate: endDate,
      },
      headers: {
        get: {
          Authorization:
            "Bearer " +
            JSON.parse(
              sessionStorage.hasOwnProperty("token_store")
                ? sessionStorage.getItem("token_store")
                : JSON.stringify({ token: "empty" })
            ).token,
          "Content-Type": "multipart/form-data",
        },
      },
    })
      .then((response) => {
        if (response.status === 200) {
          resolve(response);
        }
        reject(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function loadDashboardAdsData_UserConcurrent(id, endDate, startDate) {
  return new Promise((resolve, reject) => {
    axiosInstance({
      method: "get",
      url: "/mediaAd/" + id + "/concurrentUsers",
      params: {
        startingDate: startDate,
        endingDate: endDate,
      },
      headers: {
        get: {
          Authorization:
            "Bearer " +
            JSON.parse(
              sessionStorage.hasOwnProperty("token_store")
                ? sessionStorage.getItem("token_store")
                : JSON.stringify({ token: "empty" })
            ).token,
          "Content-Type": "multipart/form-data",
        },
      },
    })
      .then((response) => {
        if (response.status === 200) {
          resolve(response);
        }
        reject(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function loadDashboardAdsData_ConexionesByDate(id, endDate, startDate) {
  return new Promise((resolve, reject) => {
    axiosInstance({
      method: "get",
      url: "/mediaAd/" + id + "/usedConnections",
      params: {
        startingDate: startDate,
        endingDate: endDate,
      },
      headers: {
        get: {
          Authorization:
            "Bearer " +
            JSON.parse(
              sessionStorage.hasOwnProperty("token_store")
                ? sessionStorage.getItem("token_store")
                : JSON.stringify({ token: "empty" })
            ).token,
          "Content-Type": "multipart/form-data",
        },
      },
    })
      .then((response) => {
        if (response.status === 200) {
          resolve(response);
        }
        reject(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function loadMediaAds() {
  return new Promise((resolve, reject) => {
    axiosInstance({
      method: "get",
      url: "/mediaAd/",
      headers: {
        get: {
          Authorization:
            "Bearer " +
            JSON.parse(
              sessionStorage.hasOwnProperty("token_store")
                ? sessionStorage.getItem("token_store")
                : JSON.stringify({ token: "empty" })
            ).token,
        },
      },
    })
      .then((response) => {
        if (response.status === 200) {
          resolve(response.data);
        }
        reject(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function load_ZoneMediaAd(zoneList, campaignId) {
  return new Promise((resolve, reject) => {
    axiosInstance({
      method: "get",
      url: "/mediaAd/zone",
      headers: {
        get: {
          Authorization:
            "Bearer " +
            JSON.parse(
              sessionStorage.hasOwnProperty("token_store")
                ? sessionStorage.getItem("token_store")
                : JSON.stringify({ token: "empty" })
            ).token,
        },
      },
      params: {
        zoneIdList: zoneList,
        campaignId: campaignId,
      },
      paramsSerializer: (params) => {
        console.log(params);
        return qs.stringify(params, { arrayFormat: "repeat" });
      },
    })
      .then((response) => {
        if (response.status === 200) {
          resolve(response);
        }
        reject(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function load_MediaAdInfoMap(zoneList, campaignId, mediaAdId) {
  return new Promise((resolve, reject) => {
    axiosInstance({
      method: "get",
      url: "/mediaAd/zone/" + mediaAdId,
      headers: {
        get: {
          Authorization:
            "Bearer " +
            JSON.parse(
              sessionStorage.hasOwnProperty("token_store")
                ? sessionStorage.getItem("token_store")
                : JSON.stringify({ token: "empty" })
            ).token,
        },
      },
      params: {
        zoneIdList: zoneList,
        campaignId: campaignId,
      },
      paramsSerializer: (params) => {
        console.log(params);
        return qs.stringify(params, { arrayFormat: "repeat" });
      },
    })
      .then((response) => {
        if (response.status === 200) {
          resolve(response);
        }
        reject(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function deleteMediaAd(id) {
  return new Promise((resolve, reject) => {
    axiosInstance({
      method: "delete",
      url: "/mediaAd/" + id,
      headers: {
        delete: {
          Authorization:
            "Bearer " +
            JSON.parse(
              sessionStorage.hasOwnProperty("token_store")
                ? sessionStorage.getItem("token_store")
                : JSON.stringify({ token: "empty" })
            ).token,
        },
      },
    })
      .then((response) => {
        console.log(response.status);
        if (response.status === 200 || response.status === 202) {
          resolve(response);
        }
        reject(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function updateBudget() {
  let localStg = JSON.parse(sessionStorage.getItem("token_store"));
  console.log("Antes", localStg);
  return new Promise((resolve, reject) => {
    axiosInstance({
      method: "get",
      url: "/client/info",
      headers: {
        get: {
          Authorization:
            "Bearer " +
            JSON.parse(
              sessionStorage.hasOwnProperty("token_store")
                ? sessionStorage.getItem("token_store")
                : JSON.stringify({ token: "empty" })
            ).token,
        },
      },
    })
      .then((response) => {
        if (response.status === 200 || response.status === 202) {
          console.log("updateBud", response);
          localStg.balance = response.data.balance;
          sessionStorage.setItem("token_store", JSON.stringify(localStg));
          console.log("Despuests", localStg);

          resolve(response.data);
        }
        reject(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function MediaAdsActive(startDate, endDate) {
  return new Promise((resolve, reject) => {
    axiosInstance({
      method: "get",
      url: "/referral/ads",
      params: {
        startingDate: startDate,
        endingDate: endDate,
      },
      headers: {
        get: {
          Authorization:
            "Bearer " +
            JSON.parse(
              sessionStorage.hasOwnProperty("token_store")
                ? sessionStorage.getItem("token_store")
                : JSON.stringify({ token: "empty" })
            ).token,
        },
      },
    })
      .then((response) => {
        if (response.status === 200) {
          resolve(response.data);
        }
        reject(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function ReferralAmount() {
  return new Promise((resolve, reject) => {
    axiosInstance({
      method: "get",
      url: "/referral",
      headers: {
        get: {
          Authorization:
            "Bearer " +
            JSON.parse(
              sessionStorage.hasOwnProperty("token_store")
                ? sessionStorage.getItem("token_store")
                : JSON.stringify({ token: "empty" })
            ).token,
        },
      },
    })
      .then((response) => {
        if (response.status === 200) {
          resolve(response.data);
        }
        reject(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function ProfitReferral(startDate, endDate) {
  return new Promise((resolve, reject) => {
    axiosInstance({
      method: "get",
      url: "/referral/profit",
      params: {
        startingDate: startDate,
        endingDate: endDate,
      },
      headers: {
        get: {
          Authorization:
            "Bearer " +
            JSON.parse(
              sessionStorage.hasOwnProperty("token_store")
                ? sessionStorage.getItem("token_store")
                : JSON.stringify({ token: "empty" })
            ).token,
        },
      },
    })
      .then((response) => {
        if (response.status === 200) {
          resolve(response.data);
        }
        reject(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}
